import axios from "axios";
import { MessageBox, Message } from "element-ui";
import token from "@/utils/apifoxToken";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000 * 2,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken;
    if (isToken) {
      config.headers[token.key] = token.value; // 让每个请求携带自定义token
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 如果是 401
    if (error.response?.data?.apifoxError.code === 401) {
      Message({
        message: "Token已过期，请联系管理员",
        type: "error",
        duration: 5 * 1000,
      });
    } else {
      return {
        data: {
          code: 504, // 自定义错误码(非Token过期则走本地的JSON)
        },
      };
    }
    return Promise.reject(error);
  }
);

export default service;
